import React, {useCallback, useState} from 'react';
import { Button, Col, Container, Table} from 'react-bootstrap';
import {httpClient} from "../../service";
import {ActionResult, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {Link} from 'react-router-dom';
import {getSessionVerify, TtaSecModel} from '../verifications/VerifyConfigModel';
import T5Detail from './t5Detail';

export const Verification2t5 = () => { // 추가
    const url = 'test/tta5';
    const model = getSessionVerify();
    const [loading, setLoading] = useState<boolean>(false);
    const [avg, setAvg] = useState<string>('');
    const onDeleteProcess =  useCallback(async(e: any) => {
        e.preventDefault();
        const ans = window.confirm("검증데이타를 초기화 하시겠습니까? 초기화하면 현재 검증데이타가 삭제됩니다.");
        if (ans == false) return false;
        console.log(`click button id=${e.target}`);
        setLoading(true);
        const url = `test/tta`;
        const options = {
            method: HttpMethod.DELETE,
            url,
            body: {...model, ttaNum: 5}
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            window.location.reload();
        } else {
            alert(act.errorMsg);
        }
    },[]);
    const getAvg = useCallback(async () => {
        const param = {
            url: 'test/tta/avg',
            method: HttpMethod.GET,
            query: `ttaNum=5&memberId=${model.memberId}`
        };
        const act = await httpClient(param);
        if (act.result) {
            setAvg(act.data+' Sec');
        } else {
            setAvg('N/A');
        }
    }, []);

    const options = {promiseFn: httpClient, method: HttpMethod.GET, url, body: model};

    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    const refresh = async () => {
        window.location.reload();
        alert("성공적으로 초기화 되었습니다.");
    }
    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage action={act}/>;
    const data: TtaSecModel[] = act.data;

    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm verify-bloc">
                    <div className="row mb-1">
                        <Col className="text-left col-sm-3">
                            <Link to="/verification2" className="btn btn-sm btn-primary">Home</Link>
                            &nbsp;
                            <Link to="/verification2/config" className="btn btn-sm btn-info">환경설정</Link>
                            &nbsp;
                            <Button className="btn-danger" size="sm" onClick={onDeleteProcess}
                                    disabled={loading}>초기화</Button>
                            &nbsp;
                            <Button className="btn-secondary" size="sm" onClick={refresh}>새로고침</Button>

                        </Col>
                        <Col className={'text-center col-sm-6'}>
                            검증5
                        </Col>
                        <Col className="text-right col-sm-3">
                            [회원번호: <span className="text-primary">{model.custNo}</span>]
                        </Col>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table striped bordered hover size="sm" variant="dark" className={'tta'}>
                                <colgroup>
                                    <col style={{width: '40px'}}/>
                                    <col style={{width: '70px'}}/>
                                    <col style={{width: '120px'}}/>
                                    <col/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '80px'}}/>
                                    <col style={{width: '80px'}}/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th className="align-center">#</th>
                                    <th className="align-center">가맹점ID</th>
                                    <th className="align-center">가맹점명</th>
                                    <th className="align-center">확인/검증</th>
                                    <th className="align-center">인증요청</th>
                                    <th className="align-center">인증완료</th>
                                    <th className="align-center">인증속도</th>
                                    <th className="align-center">검증</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data && data.map((item, i) => {
                                        return <T5Detail item={item} key={i} index={i}/>
                                    })
                                }
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td colSpan={6}>
                                        <div className={'text-right'}><Button size="sm" onClick={getAvg}>평균속도 계산</Button></div>
                                    </td>
                                    <td colSpan={2} className={'result'}>{avg}</td>

                                </tr>
                                </tfoot>
                            </Table>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
};

